import React from 'react'
import {Form, Input} from 'antd'
import {ExportOutlined} from '@ant-design/icons'
import get from 'lodash.get'
import {groupBy} from 'lib/util'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import SelectablePhotoThumb from 'components/shared/SelectablePhotoThumb'

function productFields(product) {
  switch (product.__typename) {
    case 'DigitalRetouchedRenovationPhotoProduct':
      return [
        {value: 'wall', label: 'Veggkode'},
        {value: 'floor', label: 'Gulvkode'},
        {value: 'furnishing', label: 'Møbelkode'},
      ]
    case 'DigitalRetouchedPeoplePhotoProduct':
      return [
        {value: 'person', label: 'Personkode'},
      ]
    default:
      return [
        {value: 'furnishing', label: 'Møbelkode'},
      ]
  }
}

function urlForFurnitureCatalogue(roomName, product) {
  if (product.__typename === 'DigitalRetouchedPeoplePhotoProduct') {
    return 'https://efkt.app/pip/'
  }

  const rooms = {
    stue: 1,
    bad: 8,
    soverom: 2,
    kjøkken: 13
  }

  const pageId = rooms[roomName]
  const path = pageId ? `/room/${pageId}` : ''
  return `https://www.virtualfurniture.io${path}?c=porjWMwM1N`
}

const FormFields = ({product, onSubmit, onCancel, photos, isSubmitting}) => {
  const [form] = Form.useForm()
  const photosGroupedByRoom = groupBy(photos, p => get(p, 'image.labels[0]', 'annet'))

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onSubmit}
      className="retouch-styles-form"
    >
      {Object.entries(photosGroupedByRoom).map(([room, roomPhotos]) => (
        <React.Fragment key={room}>
          <Heading level={3}>
            <span className="room-name">{room}</span>
            <a href={urlForFurnitureCatalogue(room, product)} target="_blank" rel="noopener noreferrer">
              <Button
                secondary
                size="small"
                icon={<ExportOutlined />}
              >
                Stilalternativer
              </Button>
            </a>
          </Heading>

          <div className="photos-wrapper">
            {roomPhotos.map((photo, i) => (
              <div key={photo.id} className="selected-photo">
                <SelectablePhotoThumb
                  key={photo.id}
                  isSelectable={false}
                  photo={photo}
                />
                <div className="form-fields">
                  {productFields(product).map(({label, value}) => (
                    <Form.Item
                      rules={[{required: true, message: 'Kode er påkrevd'}]}
                      name={[photo.id, value]}
                      key={[photo.id, value]}
                      label={label}
                    >
                      <Input />
                    </Form.Item>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}

      <div className="actions">
        <Button
          secondary
          type="navigation"
          disabled={isSubmitting}
          onClick={onCancel}
        >
          Tilbake
        </Button>
        <Button
          htmlType="submit"
          type="action"
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Send til redigering
        </Button>
      </div>
    </Form>
  )
}

export default FormFields
